import { sections } from '@/mocks/audit'
import { displayWarning } from '@/utils/notification-factory'
import { message } from '@/utils/app-messages'
import { gradableSections } from '@/utils/audit'

const sectionOrder = [
  ...Reflect.ownKeys(sections),
  'additional-components',
  'next-steps'
]
const audit = {
  namespaced: true,
  state: {
    audits: [],
    currentAudit: null,
    _id: null,
    planId: null,
    assignmentId: null,
    sections: [
      //   {
      //   id: null,
      //   grade: null,
      //   score: null,
      //   criteria: [],
      //   comments: null,
      //   savedAt: null,
      //   updatedAt: null
      // }
    ],
    lastSection: null,
    nextSection: null,
    scores: {
      0: 0,
      1: 3,
      2: 2,
      3: 1,
      4: 0
    },
    scoresByKeys: {
      outstanding: 3,
      good: 2,
      requires_improvement: 1,
      inadequate: 0,
      not_applicable: 0
    },
    finalGrading: null,
    rawScore: 0,
    weightedScore: 0,
    createdAt: null,
    updatedAt: null,
    completedAt: null,
    error: null,
    loadingPDF: false
  },
  mutations: {
    SET_AUDITS(state, audits) {
      audits.map(audit => {
        console.log('SET_AUDITS', audit.sections)

        audit.lastSection = audit.sections.length
          ? audit.sections
            .slice()
            .sort((a, b) => (a.id < b.id ? -1 : 1))
            .pop().id
          : 'a'
        audit.nextSection = audit.sections.length
          ? sectionOrder[
            sectionOrder.findIndex(
              s =>
                s ===
              audit.sections
                .slice()
                .sort((a, b) => (a.id < b.id ? -1 : 1))
                .pop().id
            ) + 1
          ]
          : 'a'
        return audit
      })
      state.audits = audits
    },
    SET_AUDIT(state, assignment) {
      state.currentAudit =
        typeof assignment === 'string'
          ? state.audits
            .slice()
            .find(a => a.assignmentId && a.assignmentId._id === assignment)
          : assignment
    },
    AUDIT_START(state, { assignmentId, planId, auditId }) {
      state.assignmentId = assignmentId
      state.planId = planId
      state._id = auditId
      state.createdAt = Date.now()

      if (!auditId) {
        this.$api.updateAudit('null', {
          type: 'AUDIT_START',
          calledWith: { assignmentId, planId, auditId }
        })
      }
    },
    SET_GRADE(state, grade) {
      const indexOfExisting = state.sections.findIndex(
        section => section.id === grade.id
      )

      grade.updatedAt = Date.now()
      grade.score = state.scores[grade.grade]
      if (indexOfExisting > -1) {
        state.sections[indexOfExisting] = { ...grade }
        return
      }
      state.sections.push(grade)
    },
    SET_DEFAULT_GRADING(state) {
      if (state.sections.length) return
      for (const section in sections) {
        state.sections.push({
          id: section,
          name: sections[section].name,
          currentGrade: {},
          determination: 'Section Incomplete'
        })
      }
    },
    CHECK_GRADING(state) {
      if (
        !state.currentAudit ||
        !state.currentAudit.sections ||
        !gradableSections.every(
          sec => state.currentAudit.sections.findIndex(({ id }) => id === sec) !== -1
        )
        // state.currentAudit.sections.filter(s => s.determination && s.determination.match(/^ *$/)).length !== 0

      ) {
        console.log({ sectionOrder: sectionOrder, state: state.currentAudit })
        state.finalGrading = 'Not Completed'
        return
      }
      console.log({ sectionOrder: sectionOrder, state: state.currentAudit })
      const submittedSections = state.currentAudit.sections.slice()
      const inadequate =
        submittedSections.filter(s => s.determination === 'inadequate') || []
      const requiresImprovement =
        submittedSections.filter(
          s => s.determination === 'requires_improvement'
        ) || []
      const good =
        submittedSections.filter(s => s.determination === 'good') || []
      const outstanding =
        submittedSections.filter(s => s.determination === 'outstanding') || []
      const lengths = {
        outstanding: {
          count: outstanding.length,
          sections: outstanding.map(o => o.id)
        },
        good: {
          count: good.length,
          sections: good.map(g => g.id)
        },
        reqImp: {
          count: requiresImprovement.length,
          sections: requiresImprovement.map(ri => ri.id)
        },
        inadequate: {
          count: inadequate.length,
          sections: inadequate.map(i => i.id)
        }
      }

      const provisionsSubmitted = [
        ...lengths.outstanding.sections,
        ...lengths.good.sections,
        ...lengths.inadequate.sections].filter(s => s.match(/[bc]/gi))

      const majority = provisionsSubmitted.length === 2 ? 7 / 2 : 5 / 2

      let isOutstanding = lengths.outstanding.count > majority
      let isGood = lengths.good.count > majority

      isOutstanding = lengths.inadequate.count > 0 ? false : isOutstanding
      isGood = lengths.inadequate.count > 0 ? false : isGood

      /**
       * The overall grade is inadequate if:
       *
       * 1. Two or more sections are graded as inadequate; or
       * 2. Sections D-F (Outcomes & Provisions) are inadequate.
       */

      const isInadequate = lengths.inadequate.count > 2 ||
        lengths.inadequate.sections.filter(s => s.match(/[d-f]/gi)).length > 0

      state.finalGrading = isInadequate
        ? 'inadequate'
        : isOutstanding
          ? 'outstanding'
          : isGood
            ? 'good'
            : 'requires_improvement'
    },
    AUDIT_CONTINUE(state, { assignmentId, planId, audit }) {
      if (!audit) {
        audit = {
          _id: null,
          sections: [],
          createdAt: 0
        }

        this.$api.updateAudit('null', {
          type: 'AUDIT_CONTINUE',
          calledWith: { assignmentId, planId, audit }
        })
      }
      state.assignmentId = assignmentId
      state.planId = planId
      state._id = audit._id
      state.sections = audit.sections
      state.createdAt = audit.createdAt
      state.lastSection = audit.sections.length
        ? audit.sections
          .slice()
          .sort((a, b) => (a.id < b.id ? -1 : 1))
          .pop().id
        : 'a'

      state.nextSection = audit.sections.length
        ? sectionOrder[
          sectionOrder.findIndex(
            s =>
              s ===
            audit.sections
              .slice()
              .sort((a, b) => (a.id < b.id ? -1 : 1))
              .pop().id
          ) + 1
        ]
        : 'a'

      if (!audit._id) {
        this.$api.updateAudit('null', {
          type: 'AUDIT_START',
          calledWith: { assignmentId, planId, audit }
        })
      }
    },
    AUDIT_END(state) {
      state.completedAt = Date.now()
    },
    FETCH_START(state) {
      state.fetchStart = Date.now()
    },
    FETCH_END(state) {
      state.fetchEnd = Date.now()
    },
    AUDIT_ERROR(state, err) {
      state.error = err
    },
    SET_AUDIT_SECTIONS(state, sections) {
      state.sections = sections
      state.currentAudit.sections = sections
    },
    RESET(state) {
      state._id = null
      state.currentAudit = null
      state.planId = null
      state.assignmentId = null
      state.sections = []
      state.lastSection = null
      state.nextSection = null
      state.finalGrading = null
      state.rawScore = 0
      state.weightedScore = 0
      state.createdAt = null
      state.updatedAt = null
      state.completedAt = null
    },
    SET_LOADING_STATUS(state, newLoadingStatus) {
      state.loadingSummaryPDF = newLoadingStatus
    }
  },
  actions: {
    reset({ commit }) {
      console.log('audit reset')
      commit('RESET')
    },
    async setGrade({ commit, state }, grade) {
      const isSpecialCase =
        grade.id === 'additional-components' || grade.id === 'next-steps'
      grade.gradedAt = Date.now()

      if (typeof grade.grade !== 'number' && !isSpecialCase) {
        return Promise.reject(new Error('No grading given.'))
      }
      try {
        if (!state._id) {
          await this.$api.updateAudit('null', {
            forcedNull: true,
            state
          })
          displayWarning(message.FAILED_TO_SAVE_AUDIT)
        } else {
          const { data: audit } = await this.$api.updateAudit(state._id, {
            ...grade
          })
          commit('SET_AUDIT', audit)
          commit('CHECK_GRADING')
        }
      } catch (err) {
        console.log({ err })
      }
      commit('SET_GRADE', grade)
      return Promise.resolve(grade)
    },
    async dedupeSection({ commit, state }, section) {
      try {
        const audit = await this.$api.dedupeSection(state._id, section)
        commit('SET_AUDIT_SECTIONS', [...audit.data.sections])
        return Promise.resolve(audit)
      } catch (err) {
        commit('AUDIT_ERROR', err)
        return Promise.reject(err)
      }
    },
    async setDefaultGrading({ commit }) {
      commit('SET_DEFAULT_GRADING')
      return Promise.resolve()
    },
    setCurrentAudit({ commit }, assignmentId) {
      commit('SET_AUDIT', assignmentId)
    },
    checkGrading({ commit }) {
      commit('CHECK_GRADING')
    },
    async beginAudit({ commit }, { assignmentId, planId }) {
      const { data: audit } = await this.$api.setBeginAudit(assignmentId)
      commit('AUDIT_START', { assignmentId, planId, auditId: audit._id })
    },
    async continueAudit({ commit }, { assignmentId, planId }) {
      try {
        const { data: audit } = await this.$api.continueAudit(assignmentId)
        commit('AUDIT_CONTINUE', { assignmentId, planId, audit })
        commit('CHECK_GRADING')
        return Promise.resolve(audit)
      } catch (err) {
        commit('AUDIT_ERROR', err)
        return Promise.reject(err)
      }
    },
    async completedAudit({ commit, state, dispatch }) {
      try {
        await this.$api.setAuditComplete(state._id, state.finalGrading)
        dispatch('assignment/fetchAssignments', null, { root: true })
        commit('AUDIT_END')
      } catch (err) {
        commit('AUDIT_ERROR', err)
      }
    },
    async getAudits({ commit }) {
      try {
        const data = await this.$api.getUsersAudits()
        commit('SET_AUDITS', data.data)
      } catch (error) {
        console.log('get audits error', error)

        return Promise.reject(error)
      }
    },
    getOurBenchmarkData() {
      return this.$api.getOurBenchmarkData()
    },
    async fetchSummaryPDF({ commit }, { assignmentId, filename }) {
      commit('SET_LOADING_STATUS', true)
      try {
        const { data: pdfbuffer } = await this.$api.fetchSummaryPDF(
          assignmentId
        )
        // eslint-disable-next-line no-undef
        const url = window.URL.createObjectURL(new Blob([pdfbuffer]))
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.setAttribute('download', filename || 'audit-summary.pdf')
        document.body.appendChild(link)
        link.click()
        commit('SET_LOADING_STATUS', false)
      } catch (err) {
        commit('FETCH_ERROR', {
          name: 'getSummaryPDF',
          err,
          date: Date.now()
        })
        commit('SET_LOADING_STATUS', false)
      }
    }
  },
  getters: {
    audits: state => state.audits,
    sections: state => state.sections,
    lastSection: state => state.lastSection,
    nextSection: state => state.nextSection,
    scoreLookup: state => state.scores,
    scoreKeyLookup: state => state.scoresByKeys,
    currentAudit: state => Object.assign({}, state.currentAudit),
    id: state => state._id,
    finalGrading: state => state.finalGrading,
    loadingPDF: state => state.loadingPDF
  }
}

export default audit
